import type { Action, Thunk } from 'easy-peasy';
import { action, thunk } from 'easy-peasy';
import type { StoreModel } from '../..';
import parseStatusCode from '../../errors/parseStatusCode';
import type { Injections } from '../../services/injections';
import type { ApplicationErrorOptions } from '../../../types';
import type { PartnerLaneOrchestration } from '@shipium-corp/shipium-ts-types';

export interface DockLanesModel {
  dockLanesMap: Record<string, PartnerLaneOrchestration>;
  setDockLanes: Action<DockLanesModel, PartnerLaneOrchestration[]>;
  setDockLane: Action<DockLanesModel, PartnerLaneOrchestration>;
  fetchDockLanesLoading: boolean;
  setFetchDockLanesLoading: Action<DockLanesModel, boolean>;
  fetchDockLanes: Thunk<DockLanesModel, void, Injections, StoreModel, Promise<void>>;
  fetchDockLanesFailure: Action<DockLanesModel, ApplicationErrorOptions>;
}

export const dockLanesModel: DockLanesModel = {
  dockLanesMap: {},
  setDockLanes: action((state, dockLanes) => {
    const dockLanesMap = dockLanes.reduce<Record<string, PartnerLaneOrchestration>>((acc, curr) => {
      acc[curr.laneId as string] = curr;
      return acc;
    }, {});
    state.dockLanesMap = dockLanesMap;
  }),
  setDockLane: action((state, dockLane) => {
    state.dockLanesMap[dockLane.laneId as string] = dockLane;
  }),
  fetchDockLanesLoading: false,
  setFetchDockLanesLoading: action((state, isLoading) => {
    state.fetchDockLanesLoading = isLoading;
  }),
  fetchDockLanes: thunk(async (actions, payload, { injections, getState }) => {
    try {
      actions.setFetchDockLanesLoading(true);
      const { fulfillmentContextService } = injections;
      const response = await fulfillmentContextService.fetchDockLanes();
      actions.setDockLanes(response);
      actions.setFetchDockLanesLoading(false);
      return response;
    } catch (error) {
      actions.fetchDockLanesFailure({
        error,
        httpCode: parseStatusCode(error),
        asNotification: false,
        message: error instanceof Error ? error.message : 'An error occurred, unable to fetch asset details',
      });
      actions.setFetchDockLanesLoading(false);
      return error;
    }
  }),
  fetchDockLanesFailure: action((state, error) => {
    console.error(error);
  }),
};

export default dockLanesModel;
